import { Col, Row } from "antd";
import "antd/dist/reset.css";
import "../../containers/customLayout.css";
import { ParagraphHeader } from "@seims/shared";

const AboutEventTracker = () => {
  return (
    <>
      <Row>
        <Col xs={24}>
          <ParagraphHeader header="SEIMS Events App" />
          <Row style={{ justifyContent: "center" }} >
            <Col xs={24} sm={20} md={18} >
              <div className="public-portal-section-text about-text">
                <p>
                  {/* The Department of Science and Innovation-National Youth
                      Service (DSI-NYS) programme is a component of the
                      government's overall National Youth Service Programme
                      (NYS). Managed by the South African Agency for Science and
                      Technology Advancement of the National Research
                      Foundation, the DSI-NYS programme places unemployed
                      graduates who are under 35 years old in partner
                      institutions for 12 months while also providing them with
                      monthly stipends to cover their basic needs.{" "} */}
                  {/* The Events Tracker App enables event organisers of science awareness/promotion events to easily register and manage their events. No personal information of the attendees is required during capturing thus simplifying the capturing process. You will also be able to capture attendees in areas with poor/no Internet connectivity. During this time the attendance will be recorded and seamlessly synced once Internet connectivity is restored. Once your event is concluded, you will have access your event analytics. */}
                
                  A range of special events are organised as part of the science engagement programme to facilitate knowledge exchange between scientists, 
                  or knowledge intermediaries and the public. The annual National Science Month, public engagement with research dialogue sessions, science cafés, 
                  and exhibitions are a few examples of science engagement events. Participant data from these events is uploaded to SEIMS to aid in the 
                  identification of emerging trends and patterns in the science engagement programme and to prepare for various forms of periodic evaluations. 
                  Two essential transformation indicators can be tracked with the help of the data gathered from science engagement events: the participant 
                  demographics and the geographical distribution of the events. 
                </p>
                <p>If you are an individual or organisation that organises and hosts science engagement events, you can help create a national profile of these 
                  events by uploading participant data to SEIMS. 
                  {/* The SEIMS Events App, which can be downloaded for free from the Google Play Store to your 
                  Android device, must be used to successfully register your event in order for you to upload data to SEIMS. */}
                  </p>

              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export default AboutEventTracker;